import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CaseTitleTooltip from '../tooltips/caseTitleTooltip/CaseTitleTooltip';
import { mapValidationFieldsToClassName } from '../../forms/inputValidations';


class CaseTitleSelector extends Component {
  componentWillReceiveProps(nextProps) {
    this.refs.case_title.value = nextProps.value || '';
  }

  onChange = () => {
    const { value } = this.refs.case_title;
    this.props.onChange({ case_title: value });
  }

  render() {
    return (
      <div className="form-item">
        <label htmlFor="case-title">Case Title: </label>
        <input type="text"
               maxLength="128"
               id="case-title"
               size="60"
               ref="case_title"
               onChange={this.onChange}
               className={this.props.className} />
        <CaseTitleTooltip />
      </div>
    );
  }
}

CaseTitleSelector.defaultProps = {
  className: '',
  value: '',
};

CaseTitleSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.any,
  value: PropTypes.any,
};


function mapStateToProps(state) {
  return {
    className: mapValidationFieldsToClassName(state, 'case_title', 'input-search').className,
    value: state.getIn(['pacerSearchResults', 'filters', 'case_title']),
  };
}

export default connect(mapStateToProps)(CaseTitleSelector);



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/caseSelector/CaseTitleSelector.jsx
 **/